import { createContext } from "react";

const UserContextCurrency = createContext();

export default UserContextCurrency;